(function () {
    'use strict';

    /**
     * faq-jsonld.js
     * Scans all .ccr-faq blocks on the page and injects a single
     * FAQPage JSON-LD <script> into <head>.
     *
     * HTML contract (from ccr-content-snippets.md):
     *   <div class="ccr-faq">
     *     <details class="ccr-faq-q">
     *       <summary>Question text</summary>
     *       <div class="ccr-faq-a">Answer text</div>
     *     </details>
     *   </div>
     *
     * Google's FAQPage limit is 5 Q&A pairs shown as rich results,
     * but we emit all of them for crawlability.
     */
    function buildFaqJsonLd() {
        var faqs = document.querySelectorAll('.ccr-faq');
        if (!faqs.length) return;

        var questions = [];

        faqs.forEach(function (faq) {
            faq.querySelectorAll('.ccr-faq-q').forEach(function (q) {
                var qEl = q.querySelector('summary');
                var aEl = q.querySelector('.ccr-faq-a');
                if (!qEl || !aEl) return;

                var questionText = qEl.textContent.trim();
                var answerText   = aEl.textContent.trim();
                if (!questionText || !answerText) return;

                questions.push({
                    '@type': 'Question',
                    'name': questionText,
                    'acceptedAnswer': {
                        '@type': 'Answer',
                        'text': answerText
                    }
                });
            });
        });

        if (!questions.length) return;

        var ld = document.createElement('script');
        ld.type = 'application/ld+json';
        ld.textContent = JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            'mainEntity': questions
        });
        document.head.appendChild(ld);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', buildFaqJsonLd);
    } else {
        buildFaqJsonLd();
    }
})();
